import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import moment from 'moment-timezone'
import axios from 'axios'
import {
  Row,
  Col,
  DetailList,
  ContentSectionBlock,
  ContentSection
} from 'camino-react'

import ListOfLinkedItems from './ListOfLinkedItems'

import { simpleHtmlFormat } from 'Utilities/StringManipulator'

class ShowNotice extends Component {
  constructor (props) {
    super(props)

    this.state = { clients: [] }

    this.calculateClientsForFetch = this.calculateClientsForFetch.bind(this)
    this.fetchClients = this.fetchClients.bind(this)
  }

  componentDidMount = async () => {
    const { noticeItems } = this.props

    const userForFetch = this.calculateClientsForFetch(noticeItems)
    const clients = await this.fetchClients(userForFetch)

    this.setState({
      clients: clients.data
    })
  }

  calculateClientsForFetch = (notices) => {
    const clientNotices = _.filter(notices, ['type', 'Client'])
    const clientsForFetch = _.flatMap(
      clientNotices, noticeItem => noticeItem.id
    )
    return (
      _.uniq(clientsForFetch)
    )
  }

  fetchClients = async (clientsIds) => {
    if (!_.isEmpty(clientsIds)) {
      try {
        return await axios.get('/api/clients', {
          params: {
            client_ids: clientsIds
          }
        })
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
      }
    }
    return []
  }

  render () {
    const {
      clients
    } = this.state
    const {
      notice,
      noticeItems
    } = this.props
    const tickets = _.filter(noticeItems, ['type', 'Ticket'])
    const problems = _.filter(noticeItems, ['type', 'Problem'])
    const clientNotices = _.filter(noticeItems, ['type', 'Client'])
    const loadingClient = !_.isEmpty(clientNotices) && _.isEmpty(clients) ? 'Loading ...' : ''
    return (
      <Row>
        <Col width={15}>
          <ContentSection card>
            <ContentSectionBlock title="Notice Information">
              <DetailList
                list={[
                  {
                    title: 'Content',
                    content: simpleHtmlFormat(notice.content)
                  }
                ]}
              />
              <DetailList
                list={[
                  {
                    title: 'Creator',
                    content: notice?.creator?.name || 'Unknown'
                  },
                  {
                    title: 'Created',
                    content: moment(notice.created_at).format('DD MMMM YYYY, hh:mmA')
                  }
                ]}
              />
            </ContentSectionBlock>
          </ContentSection>
        </Col>

        <Col>
          <ContentSection card>
            <ContentSectionBlock title="Currently showing for:">
              <ListOfLinkedItems
                clients={clients}
                tickets={tickets}
                problems={problems}
                clientNotices={clientNotices}
                loadingClient={loadingClient}
              />
            </ContentSectionBlock>
          </ContentSection>
        </Col>
      </Row>
    )
  }
}

export default ShowNotice

ShowNotice.propTypes = {
  notice: PropTypes.objectOf(PropTypes.any).isRequired,
  noticeItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  noticeType: PropTypes.string.isRequired
}
